import * as React from "react";
import Component from "../../AbstractComponent";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Constants from "../../../Action/Constants";
import FinanceTabsWillMount from "../../../Middleware/Middlewares/FinanceTabsWillMount";
import {MiddlewareInterface} from "../../../Middleware/MiddlewareInterface";

export class TabsComponent extends Component {
    protected middlewares: MiddlewareInterface[] = [
        FinanceTabsWillMount
    ];

    public state = {
        value: this.props.activeTab
    };

    constructor(public props) {
        super(props);
    }

    public saveIndexToStore = (index: number): void => {
        this.props.dispatch({
            type: Constants.PAGE_FINANCE_UPDATE_SWITCH_TAB,
            payload: {
                index: index
            }
        });
    }

    public componentDidMount() {
        this.saveIndexToStore(this.state.value);
    }

    // @ts-ignore
    public switchTab = (event, tabValue) => {

        this.setState({
            value: tabValue
        });

        let redirect: string = "charge";

        switch (tabValue) {
            case 0:
                redirect = "charge";
                break;

            case 1:
                redirect = "payment";
                break;

            case 2:
                redirect = "owner-statements";
                break;

            case 3:
                redirect = "savings";
                break;

            case 4:
                redirect = "reports";
                break;

            case 5:
                redirect = "invoices";
                break;

            case 6:
                redirect = "agency-statements";
                break;
        }

        this.redirect(`/app/finance/${redirect}`);
    }

    public render() {
        return (
            <Tabs
                className={`tab tab-simple tab-contains-5 half-size light-tabs`}
                value={this.state.value}
                onChange={this.switchTab}
            >
                <Tab
                    value={0}
                    label={this.trans("title-charges")}
                />

                <Tab
                    value={1}
                    label={this.trans("title-payments")}
                />

                <Tab
                    value={2}
                    label={this.trans("title-statements")}
                />

                {this.isBeta() &&<Tab
                    value={6}
                    label={this.trans("title-agency-statements")}
                />}

                <Tab
                    value={3}
                    label={this.trans("title-savings")}
                />

                <Tab
                    value={4}
                    label={this.trans("title-reports")}
                />

                <Tab
                    value={5}
                    label={this.trans("title-invoices")}
                />

            </Tabs>
        );
    }
}
